import { Component, Input, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HelpService } from '../../../chatstyle/help/help.service';
import { Help } from '../../models/core.model';

@Component({
  selector: 'app-page-header',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './page-header.component.html',
  styleUrls: ['./page-header.component.scss']
})
export class PageHeaderComponent implements OnInit {
  @Input() title: string = '';
  @Input() subtitle: string = '';
  @Input() helpUrl: string = '';
  @Input() helpText: string = '';

  public resolvedHelpUrl: string = '';
  public isLoadingHelp: boolean = false;

  constructor(private helpService: HelpService) {}

  ngOnInit() {
    this.resolveHelpUrl();
  }

  private resolveHelpUrl() {
    if (!this.helpUrl) {
      this.resolvedHelpUrl = '';
      return;
    }

    // Check if it's already a valid URL
    if (this.isValidUrl(this.helpUrl)) {
      this.resolvedHelpUrl = this.helpUrl;
      return;
    }

    // Check if it's a pipe-delimited string (category|item)
    if (this.helpUrl.includes('|')) {
      const parts = this.helpUrl.split('|');
      if (parts.length === 2) {
        const category = parts[0].trim();
        const item = parts[1].trim();

        if (category && item) {
          this.isLoadingHelp = true;
          this.helpService.get(category, item)
            .then((result: Help) => {
              this.resolvedHelpUrl = result?.documentationUrl || '';
              this.isLoadingHelp = false;
            })
            .catch(error => {
              console.error('Error loading help:', error);
              this.resolvedHelpUrl = '';
              this.isLoadingHelp = false;
            });
          return;
        }
      }
    }

    // Fallback: treat as direct URL even if validation failed
    this.resolvedHelpUrl = this.helpUrl;
  }

  private isValidUrl(string: string): boolean {
    try {
      new URL(string);
      return true;
    } catch {
      return false;
    }
  }
}
